import * as React from 'react'
import * as classnames from 'classnames'

import ItemPreviewCard from '../../itemCard/itemPreviewCard/itemPreviewCard'
import { IItem } from '../../../../typings/searchResults'

import * as styles from './itemsSlideBlock.module.css'

interface IProps {
  title: string
  subtitle?: string
  data: IItem[]
  headerAlign?: 'left' | 'right'
  hideSlideOnMobile?: boolean
  onItemClick?: (item: IItem, index: number) => void
}

const ItemsSlideBlock: React.SFC<IProps> = ({
  data,
  title,
  subtitle,
  headerAlign = 'left',
  hideSlideOnMobile = false,
  onItemClick = () => {},
  children
}) => {
  const desktopHeaderStyles = classnames(styles.desktopHeader, {
    [styles.headerAlignRight]: headerAlign === 'right'
  })

  const slideStyles = classnames(styles.slide, {
    [styles.hideSlideOnMobile]: hideSlideOnMobile
  })
  return (
    <section className={styles.root}>
      <header className={styles.mobileHeader}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </header>
      <div className={slideStyles}>
        <div className={styles.slideInner}>
          <div className={styles.itemsGrid}>
            {data.map((item, index) => (
              <ItemPreviewCard
                key={index}
                item={item}
                onClick={() => onItemClick(item, index)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.textContent}>
        <header className={desktopHeaderStyles}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </header>
        {children}
      </div>
    </section>
  )
}

export default ItemsSlideBlock
